module.exports = __webpack_public_path__ + "img/Michael O’Sullivan UCC.214d904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial/Michael O’Sullivan UCC.jpg
// module id = 1180
// module chunks = 1